import { Card, Dialog, DialogContent, Typography } from "@mui/material";
import { ModuleCardProps } from "../../Utils/Types";
import style from "../../Styles/courses.module.css";
import PreviewPDFDoc from "../Widgets/PreviewPDFDoc";
import { useState } from "react";
import Videos from "../Videos/Videos";

export default function ModuleCard(props: ModuleCardProps) {
  const { module } = props;
  const [open, setOpen] = useState(false);

  const handleOnClick = () => {
    setOpen(true);
  };

  const ModuleWrapper = ({
    title,
    children,
  }: {
    children: React.ReactNode;
    title: string;
  }) => {
    return (
      <Dialog
        title={title}
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
      >
        <DialogContent style={{ padding: "1rem" }}>{children}</DialogContent>
      </Dialog>
    );
  };

  return (
    <div>
      <Card className={style.card} onClick={handleOnClick}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          style={{ display: "flex", justifyContent: "center" }}
        >
          {" "}
          {module.name}
        </Typography>
        {module.mainImageId && (
          <div className={style.cardImage}>
            <img
              width="100"
              src={"/" + module.mainImageId}
              alt={module.name}
              className={style.cardImg}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.visibility = "hidden"; // hide image if not found
              }}
            />
          </div>
        )}
      </Card>
      <ModuleWrapper title={module.name || ""}>
        {module.videos &&
          module.videos.map((video: any, index: number) => {
            return (
              <div key={index}>
                <Videos iframe={video.iframe} />
              </div>
            );
          })}
        <hr />
        <div></div>

        <PreviewPDFDoc
          open={false}
          title={""}
          onClose={() => {
            setOpen(false);
          }}
          htmlContent={""}
          urls={module.documentIds.map((item: any) => {
            return "/" + item.document;
          })}
        />
      </ModuleWrapper>
    </div>
  );
}